import axios from 'axios'
import { EXCLUIR_CONEXAO } from '../types'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { URL } from '../../util/ambienteActions';

export default function excluirConexao (cod, idEmpresa) {
  const url = `${URL}/rota/empresa/${idEmpresa}/conexao/${cod}/excluir`;
  return dispatch => axios.post(url,null , SLOW_REQUEST_CONFIG).then(
      response => dispatch({
        type: EXCLUIR_CONEXAO,
        payload: response
      })
  );
}
